import { View, TextInput, Platform, type TextInputProps } from 'react-native'
import type { getRegistrationFormStyles } from './AccountRegistrationForm.styles'

interface OrgFormTextAreaProps extends TextInputProps {
  marketing: boolean
  styles: ReturnType<typeof getRegistrationFormStyles>
}

/**
 * Multi-line text area used by the organization registration form.
 * On marketing web, wraps the input in a shell so RN Web does not drop the
 * background/border (styling comes from the parent form's stylesheet).
 */
export function OrgFormTextArea({ marketing, styles, ...props }: OrgFormTextAreaProps) {
  if (marketing && Platform.OS === 'web') {
    return (
      <View style={styles.marketingWebTextAreaShell}>
        <TextInput {...props} multiline style={styles.marketingWebTextAreaInput} />
      </View>
    )
  }
  return <TextInput {...props} multiline style={styles.textArea} />
}
